import React, { useEffect, useState } from "react";
import { McSelect } from "@maersk-global/mds-react-wrapper/mc-select";
import { McOption } from "@maersk-global/mds-react-wrapper/mc-option";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useMsal } from "@azure/msal-react";
import SaveIcon from "@mui/icons-material/Save";
import { McInputDate } from "@maersk-global/mds-react-wrapper/components-core/mc-input-date";
import { McInput } from "@maersk-global/mds-react-wrapper/mc-input";
import axios from "../api/apiClient";
import { loginRequest } from "../authconfig";
import { callUsers } from "../graph";
import { apiUrl } from "../authconfig";
const ProjectStatus = ({
  productData,
  setProductData,
  projectPhaseData,
  setProjectPhaseData,
  isLiteModal,
  currentModalData,
  editId,
  setEditId = () => {},
  cancelReason,
  setCancelReason,
  notInCurrentScopeReason,
  setNotInCurrentScopeReason,

}) => {
  const { instance, accounts } = useMsal();
  const [userOptions, setUserOptions] = useState();
  const currentUser = JSON.parse(sessionStorage.getItem("user"));

  useEffect(() => {
    if (accounts.length > 0) {
      // Silently acquire an access token to call Microsoft Graph
      instance
        .acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        })
        .then((response) => {
          // Fetch user profile data including name and photo
          callUsers(response.accessToken).then((response) => {
            console.log("responseapi", response.userData?.value);
            setUserOptions(response.userData?.value);
          });
        })
        .catch((error) => {
          console.error("Error fetching MS Graph data: ", error);
        });
    }
  }, [accounts, instance]);

  useEffect(() => {
    if (
      !projectPhaseData?.projectStatus ||
      projectPhaseData?.projectStatus == "Not Started"
    ) {
      setProjectPhaseData({ ...projectPhaseData, projectStatus: "On track" });
    }
  }, [projectPhaseData]);

  useEffect(() => {
    setEditId(null);
  }, []);

  const parseDateOnly = (value) => {
    if (!value) return null;
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return null;
    return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
  };

  const getDateDiffInDays = (startValue, endValue) => {
    const startDate = parseDateOnly(startValue);
    const endDate = parseDateOnly(endValue);
    if (!startDate || !endDate) return null;
    const oneDayInMs = 1000 * 60 * 60 * 24;
    return Math.floor((endDate - startDate) / oneDayInMs);
  };

  const goLiveDelayInDays = getDateDiffInDays(
    projectPhaseData?.agreementStartDate,
    projectPhaseData?.actualGoLiveDate
  );

  const isProjectGoLiveDelayedReasonApplicable = goLiveDelayInDays > 15;
  const isContactingSalesYes = projectPhaseData?.contactingSales === true;
  const contactingSalesValue =
    projectPhaseData?.contactingSales === true
      ? "true"
      : projectPhaseData?.contactingSales === false
      ? "false"
      : "";

  useEffect(() => {
    if (
      projectPhaseData?.projectGoLiveDelayedReason &&
      !isProjectGoLiveDelayedReasonApplicable
    ) {
      setProjectPhaseData((prevState) => ({
        ...prevState,
        projectGoLiveDelayedReason: "",
      }));
    }
  }, [
    projectPhaseData?.agreementStartDate,
    projectPhaseData?.actualGoLiveDate,
    isProjectGoLiveDelayedReasonApplicable,
  ]);

  console.log("projectPhaseData", productData);

  const handleProductChange = (e, index) => {
    setProductData(
      productData.map((product, i) => {
        if (i == index) {
          return { ...product, [e.target.name]: e.target.value };
        } else {
          return product;
        }
      })
    );
  };

  const handleSaveClick = (product) => {
    if (!product?.bookingReference?.trim()) {
      alert("Booking Reference field is mandatory.");
      return;
    }

    const scheduled = Number(product?.scheduledWeeklyVolume);
    const actual = Number(product?.averageActualWeeklyVolume);
    const ratio = scheduled > 0 ? actual / scheduled : null;
    if (ratio !== null && ratio < 0.75 && !product?.commentsOnLowVolume?.trim()) {
      alert("Comments on Low Volume is mandatory when volume conversion is below 75%.");
      return;
    }
    axios
      .post(
        `${apiUrl}/api/productData/save`,
        product
      )
      .then((res) => {
        setEditId(null);
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleProjectStatusChange = (e) => {
     const { name, value } = e.target;

  if (name === "contactingSales") {
    const isContactingSales = value === "true";

    setProjectPhaseData((prevState) => ({
      ...prevState,
      contactingSales: isContactingSales,
      reasonForSalesParticipation: isContactingSales
        ? prevState?.reasonForSalesParticipation || ""
        : "",
      reasonForSalesOther: isContactingSales
        ? prevState?.reasonForSalesOther || ""
        : "",
    }));
    return;
  }

  

  setProjectPhaseData({
    ...projectPhaseData,
    [name]: value,
  });

 
  if (name === "projectStatus") {
    if (value === "Cancelled") {
      setNotInCurrentScopeReason(undefined);
    } else if (value === "Not in Current Scope") {
      setCancelReason(undefined);
    } else {
      setCancelReason(undefined);
      setNotInCurrentScopeReason(undefined);
    }
  }

  if (
    name === "reasonForSalesParticipation" &&
    value !== "Others"
  ) {
    setProjectPhaseData((prevState) => ({
      ...prevState,
      reasonForSalesParticipation: value,
      reasonForSalesOther: "",
    }));
  }
  };
  const today = new Date().toISOString().split("T")[0];
  console.log("productData.", currentModalData, projectPhaseData);

  return (
    <div>
      <CardContent>
        <div
          style={{
            fontSize: "14px",
            color: "black",
            fontWeight: "normal",
            marginBottom: "10px",
          }}
        >
          Project Status and Timelines
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <div>
            <McSelect
              hiddenlabel="true"
              fit="medium"
              name="projectStatus"
              value={projectPhaseData?.projectStatus || "On track"}
              optionselected={handleProjectStatusChange}
              disabled={
                currentModalData?.projectStatus == "Cancelled" ||
                currentModalData?.projectStatus == "Not in Current Scope" ||
                currentModalData?.projectStatus == "Complete" ||
                currentModalData?.assignedUser != currentUser?.mail
              }
            >
              <McOption value="On track">On Track</McOption>
              <McOption value="On hold">On Hold</McOption>
              <McOption value="Mitigating Risk">Mitigating Risk</McOption>
              <McOption value="In Escalation">In Escalation</McOption>
              <McOption value="Cancelled">Cancelled</McOption>
              {<McOption value="Complete">Complete</McOption>}
              <McOption value="Not in Current Scope">
                Not in Current Scope
              </McOption>
            </McSelect>
            {projectPhaseData?.projectStatus === "Cancelled" && (
              <div style={{ marginTop: "20px" }}>
                <div
          style={{
            fontSize: "14px",
            color: "black",
            fontWeight: "normal",
            marginBottom: "10px",
          }}
        >
      Reason for Cancellation
    </div>
                <McSelect
                  hiddenlabel="true"
                  fit="medium"
                  name="cancelReason"
                  value={cancelReason}
                  optionselected={(e) => setCancelReason(e.target.value)}
                  placeholder="Status List"
                  isClearable
                  disabled={ currentModalData?.projectStatus == "Cancelled" ||
                currentModalData?.projectStatus == "Not in Current Scope" }
                >
                  <McOption value="Close lost (business lost)">
                    Close lost (business lost)
                  </McOption>
                  <McOption value="Non-existing opportunity">
                    Non-existing opportunity
                  </McOption>
                </McSelect>
              </div>
            )}
            {projectPhaseData?.projectStatus === "Not in Current Scope" && (
              <div style={{ marginTop: "20px" }}>
                 <div
          style={{
            fontSize: "14px",
            color: "black",
            fontWeight: "normal",
            marginBottom: "10px",
          }}
        >
      Reason for Not in Current Scope
    </div>
                <McSelect
                  hiddenlabel="true"
                  fit="medium"
                  name="notInCurrentScopeReason"
                  value={notInCurrentScopeReason}
                  optionselected={(e) =>
                    setNotInCurrentScopeReason(e.target.value)
                  }
                  placeholder="Status List"
                  isClearable
                  disabled={ currentModalData?.projectStatus == "Cancelled" ||
                currentModalData?.projectStatus == "Not in Current Scope" }
                
                >
                  <McOption value="Renewal (existing deal/volume increase)">
                    Renewal (existing deal/volume increase)
                  </McOption>
                  <McOption value="Incorrect SFDC opportunity details">
                    Incorrect SFDC opportunity details
                  </McOption>
                  <McOption value="CIM - picked up by CIM">
                    CIM - picked up by CIM
                  </McOption>
                  <McOption value="CPM - picked up by CPM">
                    CPM - picked up by CPM
                  </McOption>
                  <McOption value="TbM Ops (Delivery), FbM, MPL, etc. scope">
                    TbM Ops (Delivery), FbM, MPL, etc. scope
                  </McOption>
                </McSelect>
              </div>
            )}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "20px",
              fontSize: "14px",
            }}
          >
            <div
              style={{
                width: "100%",
                fontSize: "14px",
                color: "black",
                fontWeight: "normal",
              }}
            >
              Initial-Go-Live-Date
              <McInputDate
                hiddenlabel="true"
                min={today}
                name="estimatedGoLiveDate"
                value={projectPhaseData?.estimatedGoLiveDate}
                errormessage="Go-Live date should be greater or equal to today and cannot be a past date"
                input={handleProjectStatusChange}
                disabled={
                  projectPhaseData?.projectStatus == "Cancelled" ||
                  projectPhaseData?.projectStatus == "Not in Current Scope" ||
                  projectPhaseData?.projectStatus == "Complete" ||
                  projectPhaseData?.assignedUser != currentUser?.mail
                }
              />
            </div>
            <div
              style={{
                width: "100%",
                fontSize: "14px",
                color: "black",
                fontWeight: "normal",
              }}
            >
              HyperCare-End-Date
              <McInputDate
                hiddenlabel="true"
                name="estimatedHypercareEndDate"
                min={projectPhaseData?.estimatedGoLiveDate || today}
                errormessage="HyperCare End date should be greater or equal to Go-Live date"
                value={projectPhaseData?.estimatedHypercareEndDate}
                input={handleProjectStatusChange}
                disabled={
                  projectPhaseData?.projectStatus == "Cancelled" ||
                  projectPhaseData?.projectStatus == "Not in Current Scope" ||
                  projectPhaseData?.projectStatus == "Complete" ||
                  projectPhaseData?.assignedUser != currentUser?.mail
                }
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "20px",
              fontSize: "14px",
            }}
          >
            {isLiteModal && (
              <div
                style={{
                  width: "50%",
                  fontSize: "14px",
                  color: "black",
                  fontWeight: "normal",
                }}
              >
                1st booking reference number
                <McInput
                  hiddenlabel="true"
                  fit="medium"
                  name="firstBookingReference"
                  value={projectPhaseData?.firstBookingReference || ""}
                  input={handleProjectStatusChange}
                  disabled={
                    projectPhaseData?.projectStatus == "Cancelled" ||
                    projectPhaseData?.projectStatus == "Not in Current Scope" ||
                    currentModalData?.projectStatus == "Complete" ||
                    projectPhaseData?.assignedUser != currentUser?.mail
                  }
                />
              </div>
            )}
            <div
              style={{
                width: "50%",
                fontSize: "14px",
                color: "black",
                fontWeight: "normal",
              }}
            >
              Actual Go-Live-Date
              <McInputDate
                hiddenlabel="true"
                name="actualGoLiveDate"
                min={currentModalData?.closedWonDate}
                max={today}
                errormessage="Actual Go-Live Date cannot be a future date"
                value={projectPhaseData?.actualGoLiveDate || ""}
                input={handleProjectStatusChange}
                disabled={
                  projectPhaseData?.projectStatus == "Cancelled" ||
                  projectPhaseData?.projectStatus == "Not in Current Scope" ||
                  currentModalData?.projectStatus == "Complete" ||
                  projectPhaseData?.assignedUser != currentUser?.mail
                }

              />
            </div>
          </div>
          <div
            style={{
              fontSize: "14px",
              color: "black",
              fontWeight: "normal",
              marginBottom: "10px",
            }}
          >
            Customer Contact
            <textarea
              rows={2}
              style={{ width: "100%" }}
              name="customerContacts"
              value={projectPhaseData?.customerContacts || ""}
              onChange={(e) => handleProjectStatusChange(e)}
              disabled={
                currentModalData?.projectStatus == "Cancelled" ||
                currentModalData?.projectStatus == "Not in Current Scope" ||
                currentModalData?.projectStatus == "Complete" ||
                currentModalData?.assignedUser != currentUser?.mail
              }
            />
          </div>
          <div
            style={{
              fontSize: "14px",
              color: "black",
              fontWeight: "normal",
              marginBottom: "10px",
            }}
          >
            Internal Contact
            <textarea
              rows={2}
              style={{ width: "100%" }}
              name="internalStakeholders"
              value={projectPhaseData?.internalStakeholders || ""}
              onChange={(e) => handleProjectStatusChange(e)}
              disabled={
                currentModalData?.projectStatus == "Cancelled" ||
                currentModalData?.projectStatus == "Not in Current Scope" ||
                currentModalData?.projectStatus == "Complete" ||
                currentModalData?.assignedUser != currentUser?.mail
              }
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "20px",
              fontSize: "14px",
            }}
          >
            <div
              style={{
                width: "100%",
                fontSize: "14px",
                color: "black",
                fontWeight: "normal",
                marginBottom: "10px",
              }}
            >
              Project status is not on track
              <div>
                <McSelect
                  hiddenlabel="true"
                  fit="medium"
                  name="detailReasonForNotOnTrack"
                  value={projectPhaseData?.detailReasonForNotOnTrack || ""}
                  optionselected={handleProjectStatusChange}
                  disabled={
                    projectPhaseData?.projectStatus == "On track" ||
                    currentModalData?.projectStatus == "Cancelled" ||
                    currentModalData?.projectStatus == "Not in Current Scope" ||
                    currentModalData?.projectStatus == "Complete" ||
                    currentModalData?.assignedUser != currentUser?.mail
                  }
                >
                  <McOption value="Missing onboarding information">
                    Missing onboarding information
                  </McOption>
                  <McOption value="Customer Requested for extension">
                    Customer Requested for extension
                  </McOption>
                  <McOption value="Unforeseen Issues/system issues">
                    Unforeseen Issues/system issues
                  </McOption>
                  <McOption value="User adoption & Training delays">
                    User adoption & Training delays
                  </McOption>
                  <McOption value="Testing & Validation Failure">
                    Testing & Validation Failure
                  </McOption>
                  <McOption value="New risks identified in process">
                    New risks identified in process
                  </McOption>
                  <McOption value="New scope added in Current Scope">
                    New scope added
                  </McOption>
                  <McOption value="Service delivered below SLA">
                    Service delivered below SLA
                  </McOption>
                  <McOption value="Original go-live falling on weekend/holiday">
                    Original go-live falling on weekend/holiday
                  </McOption>
                  <McOption value="Others">Others</McOption>
                </McSelect>
              </div>
              {isProjectGoLiveDelayedReasonApplicable && (
                <div style={{ marginTop: "12px" }}>
                  <div
                    style={{
                      fontSize: "14px",
                      color: "black",
                      fontWeight: "normal",
                      marginBottom: "6px",
                    }}
                  >
                    Project go-live delayed reason
                  </div>
                  <McSelect
                    hiddenlabel="true"
                    fit="medium"
                    name="projectGoLiveDelayedReason"
                    value={projectPhaseData?.projectGoLiveDelayedReason || ""}
                    optionselected={handleProjectStatusChange}
                    disabled={
                      currentModalData?.projectStatus == "Cancelled" ||
                      currentModalData?.projectStatus == "Not in Current Scope" ||
                      currentModalData?.projectStatus == "Complete" ||
                      currentModalData?.assignedUser != currentUser?.mail
                    }
                  >
                    <McOption value="Customer is not ready as agreed">
                      Customer is not ready as agreed
                    </McOption>
                    <McOption value="Customer doesn’t have actual volume for us">
                      Customer doesn’t have actual volume for us
                    </McOption>
                    <McOption value="Sales entry of agreement start date is incorrect">
                      Sales entry of agreement start date is incorrect
                    </McOption>
                    <McOption value="CX/OPs are not ready to execute">
                      CX/OPs are not ready to execute
                    </McOption>
                    <McOption value="Systems are not ready">
                      Systems are not ready
                    </McOption>
                    <McOption value="Rates are not available">
                      Rates are not available
                    </McOption>
                    <McOption value="Product is not ready for execution">
                      Product is not ready for execution
                    </McOption>
                    <McOption value="Urgent implementation (Agreement Start Date - Close-Won date &lt;15 days)">
                      Urgent implementation (Agreement Start Date - Close-Won date &lt;15 days)
                    </McOption>
                  </McSelect>
                </div>
              )}
            </div>
            <div
              style={{
                width: "100%",
                fontSize: "14px",
                color: "black",
                fontWeight: "normal",
                marginBottom: "10px",
              }}
            >
              Detail reason for not on track_Others
              <textarea
                rows={2}
                style={{ width: "100%" }}
                name="detailReasonForNotOnTrackOthers"
                value={projectPhaseData?.detailReasonForNotOnTrackOthers || ""}
                onChange={(e) => handleProjectStatusChange(e)}
                disabled={
                  projectPhaseData?.detailReasonForNotOnTrack != "Others" ||
                  projectPhaseData?.projectStatus == "On track" ||
                  currentModalData?.projectStatus == "Complete"
                }
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "20px",
              fontSize: "14px",
            }}
          >
            <div
              style={{
                width: "100%",
                fontSize: "14px",
                color: "black",
                fontWeight: "normal",
                marginBottom: "10px",
              }}
            >
              Party responsible for not on track
              <div>
                <McSelect
                  hiddenlabel="true"
                  fit="medium"
                  name="partyResponsibleForNotOnTrack"
                  value={projectPhaseData?.partyResponsibleForNotOnTrack || ""}
                  optionselected={handleProjectStatusChange}
                  disabled={
                    projectPhaseData?.projectStatus == "On track" ||
                    currentModalData?.projectStatus == "Cancelled" ||
                    currentModalData?.projectStatus == "Not in Current Scope" ||
                    currentModalData?.projectStatus == "Complete" ||
                    currentModalData?.assignedUser != currentUser?.mail
                  }
                >
                  <McOption value="Sales">Sales</McOption>
                  <McOption value="Customer">Customer</McOption>
                  <McOption value="Operations (Delivery)">
                    Operations (Delivery)
                  </McOption>
                  <McOption value="CX">CX</McOption>
                  <McOption value="Procurement">Procurement</McOption>
                  <McOption value="Product">Product</McOption>
                  <McOption value="Others">Others</McOption>
                </McSelect>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                fontSize: "14px",
                color: "black",
                fontWeight: "normal",
                marginBottom: "10px",
              }}
            >
              Support required from
              <textarea
                rows={2}
                style={{ width: "100%" }}
                name="supportRequiredFrom"
                value={projectPhaseData?.supportRequiredFrom || ""}
                onChange={(e) => handleProjectStatusChange(e)}
                disabled={
                  projectPhaseData?.projectStatus == "On track" ||
                  currentModalData?.projectStatus == "Cancelled" ||
                  currentModalData?.projectStatus == "Not in Current Scope" ||
                  projectPhaseData?.projectStatus == "Complete" ||
                  projectPhaseData?.assignedUser != currentUser?.mail
                }
              />
              {/* <McSelect
                  hiddenlabel="true"
                  fit="medium"
                  name="supportRequiredFrom"
                  value={userOptions?.filter(user => user.mail).map(user => user.mail) || ""} 
                  optionselected={handleProjectStatusChange}
                  disabled={projectPhaseData?.projectStatus == "On track" || currentModalData?.projectStatus == "Cancelled" || currentModalData?.projectStatus == "Not in Current Scope" || projectPhaseData?.projectStatus == "Complete"}
                >
                  {userOptions?.filter(user => user.mail).map((user, index) => ( 
    <McOption key={index} value={user.mail}>
      {user.mail || ''}
    </McOption>
  ))}
                </McSelect> */}
            </div>
          </div>
          <div
            style={{
              fontSize: "14px",
              color: "black",
              fontWeight: "normal",
              marginBottom: "10px",
            }}
          >
            Comments
            <textarea
              rows={3}
              style={{ width: "100%" }}
              name="additionalComments"
              value={projectPhaseData?.additionalComments || ""}
              onChange={(e) => handleProjectStatusChange(e)}
              disabled={
                currentModalData?.projectStatus == "Cancelled" ||
                currentModalData?.projectStatus == "Not in Current Scope" ||
                projectPhaseData?.projectStatus == "Complete" ||
                currentModalData?.assignedUser != currentUser?.mail
              }
            />
          </div>
        </div>
        {!isLiteModal && (
          <>
            {" "}
            <div
              style={{
                fontSize: "16px",
                color: "black",
                fontWeight: "normal",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              Volume Conversion
            </div>
            <TableContainer component={Paper}>
              <Table className="ProjectStatusTable">
                <TableHead sx={{ backgroundColor: "#ededed", color: "black" }}>
                  <TableRow>
                    <TableCell
                      rowSpan={2}
                      sx={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      Edit
                    </TableCell>
                    <TableCell
                      colSpan={2}
                      sx={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      Product
                    </TableCell>
                    <TableCell
                      rowSpan={2}
                      sx={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      Booking Reference
                    </TableCell>
                    <TableCell
                      rowSpan={2}
                      sx={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      Total Quantity
                    </TableCell>
                    <TableCell
                      rowSpan={2}
                      sx={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      UOM
                    </TableCell>
                    <TableCell
                      rowSpan={2}
                      sx={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      GP ($Mn)
                    </TableCell>
                    <TableCell
                      rowSpan={2}
                      sx={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      Revenue ($Mn)
                    </TableCell>
                    <TableCell
                      colSpan={2}
                      sx={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      Weekly Volume
                    </TableCell>
                    <TableCell
                      rowSpan={2}
                      sx={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      Volume Conversion %
                    </TableCell>
                    <TableCell
                      rowSpan={2}
                      sx={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      Comments on Low Volume
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell sx={{ textAlign: "center" }}> Family</TableCell>
                    <TableCell sx={{ textAlign: "center" }}>Name</TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      Scheduled (SFDC)
                    </TableCell>
                    <TableCell sx={{ textAlign: "center" }}>
                      Actual (Average)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody style={{ backgroundColor: "white", color: "black" }}>
                  {productData.map((product, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <IconButton
                          disabled={
                            currentModalData?.projectStatus == "Cancelled" ||
                            currentModalData?.projectStatus ==
                              "Not in Current Scope" ||
                            currentModalData?.projectStatus == "Complete" ||
                            currentModalData?.assignedUser != currentUser?.mail
                          }
                        >
                          {editId == index ? (
                            <SaveIcon
                              onClick={(e) => handleSaveClick(product)}
                            />
                          ) : (
                            <EditIcon
                              onClick={() => {
                                console.log("Setting editId to:", index);
                                setEditId(index);
                              }}
                            />
                          )}{" "}
                        </IconButton>
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {product?.productFamily}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {product?.product}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {editId == index ? (
                          <input
                            value={product?.bookingReference || ""}
                            name="bookingReference"
                            onChange={(e) => handleProductChange(e, index)}
                            style={
                              !product?.bookingReference?.trim()
                                ? { border: "1px solid red", outline: "none" }
                                : {}
                            }
                          />
                        ) : (
                          product?.bookingReference
                        )}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {product?.totalQuantity}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {product?.uom}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {product?.productGrossProfit}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {product?.productRevenue}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {product?.scheduledWeeklyVolume}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {editId == index ? (
                          <input
                            value={product?.averageActualWeeklyVolume}
                            name="averageActualWeeklyVolume"
                            onChange={(e) => handleProductChange(e, index)}
                          />
                        ) : (
                          product?.averageActualWeeklyVolume
                        )}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {(() => {
                          const scheduled = Number(product?.scheduledWeeklyVolume);
                          const actual = Number(product?.averageActualWeeklyVolume);
                          if (scheduled === 0) return "0%";
                          const ratio = actual / scheduled;
                          return isFinite(ratio) ? (ratio * 100).toFixed(2) + "%" : "";
                        })()}
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        {(() => {
                          const scheduled = Number(product?.scheduledWeeklyVolume);
                          const actual = Number(product?.averageActualWeeklyVolume);
                          const ratio = scheduled > 0 ? actual / scheduled : null;
                          const isLowVolume = ratio !== null && ratio < 0.75;
                          if (editId == index) {
                            return (
                              <>
                                <input
                                  value={product?.commentsOnLowVolume || ""}
                                  disabled={!isLowVolume}
                                  name="commentsOnLowVolume"
                                  onChange={(e) => handleProductChange(e, index)}
                                  style={
                                    isLowVolume && !product?.commentsOnLowVolume?.trim()
                                      ? { border: "1px solid red", outline: "none" }
                                      : {}
                                  }
                                />
                                {isLowVolume && !product?.commentsOnLowVolume?.trim() && (
                                  <div style={{ color: "red", fontSize: "11px", marginTop: "2px" }}>
                                    Required
                                  </div>
                                )}
                              </>
                            );
                          }
                          return product?.commentsOnLowVolume;
                        })()}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        )}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            fontSize: "14px",
            marginTop: "16px",
          }}
        >
          <div
            style={{
              width: "100%",
              fontSize: "14px",
              color: "black",
              fontWeight: "normal",
            }}
          >
            Does this project involve contacting Sales for participation?
            <McSelect
              hiddenlabel="true"
              fit="medium"
              name="contactingSales"
              value={contactingSalesValue}
              optionselected={handleProjectStatusChange}
              disabled={
                currentModalData?.projectStatus == "Cancelled" ||
                currentModalData?.projectStatus == "Not in Current Scope" ||
                currentModalData?.projectStatus == "Complete" ||
                currentModalData?.assignedUser != currentUser?.mail
              }
            >
              <McOption value="true">Yes</McOption>
              <McOption value="false">No</McOption>
            </McSelect>
          </div>

          <div
            style={{
              width: "100%",
              fontSize: "14px",
              color: "black",
              fontWeight: "normal",
            }}
          >
            {isContactingSalesYes && (
              <>
                Reason for sales participation
                <McSelect
                  hiddenlabel="true"
                  fit="medium"
                  name="reasonForSalesParticipation"
                  value={projectPhaseData?.reasonForSalesParticipation || ""}
                  optionselected={handleProjectStatusChange}
                  disabled={
                    currentModalData?.projectStatus == "Cancelled" ||
                    currentModalData?.projectStatus == "Not in Current Scope" ||
                    currentModalData?.projectStatus == "Complete" ||
                    currentModalData?.assignedUser != currentUser?.mail
                  }
                >
                  <McOption value="Acquire customer contact details">
                    Acquire customer contact details
                  </McOption>
                  <McOption value="Validate NSS flag">
                    Validate NSS flag
                  </McOption>
                  <McOption value="Missing minimum requirement information">
                    Missing minimum requirement information
                  </McOption>
                  <McOption value="Validate business scope">
                    Validate business scope
                  </McOption>
                  <McOption value="Validate CX onboarding ownership">
                    Validate CX onboarding ownership
                  </McOption>
                  <McOption value="Incorrect use of “Closed Won”">
                    Incorrect use of “Closed Won”
                  </McOption>
                  <McOption value="Missing/Incorrect Rates">
                    Missing/Incorrect Rates
                  </McOption>
                  <McOption value="Others">
                    Others
                  </McOption>
                </McSelect>
                {projectPhaseData?.reasonForSalesParticipation ===
                  "Others" && (
                  <div style={{ marginTop: "10px" }}>
                    <textarea
                      rows={2}
                      style={{ width: "100%" }}
                      name="reasonForSalesOther"
                      value={projectPhaseData?.reasonForSalesOther || ""}
                      onChange={(e) => handleProjectStatusChange(e)}
                      disabled={
                        currentModalData?.projectStatus == "Cancelled" ||
                        currentModalData?.projectStatus == "Not in Current Scope" ||
                        currentModalData?.projectStatus == "Complete" ||
                        currentModalData?.assignedUser != currentUser?.mail
                      }
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </CardContent>
    </div>
  );
};

export default ProjectStatus;
